import React, { useCallback } from "react";
import Checkbox from "@ui-kit/form/checkbox";
import Line from "@radarly/components/panels/card-edition/sidebar/line";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import {
  DatavizLineChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";
import TimeUnitOption from "@radarly/shared/panels/card-edition/sidebar/shared/time-unit";
import PeriodEvolution from "../shared/period-evolution";

export interface SharedPanelsCardEditionSidebarOptionsLineChartProps {
  dataviz: DatavizLineChart;
  setDataviz: (dataviz: DatavizLineChart) => void;
  card: Card;
  setCard: (card: Card) => void;
  color: React.ReactElement;
}
export default function SharedPanelsCardEditionSidebarOptionsLineChart({
  card,
  setCard,
  color,
  dataviz,
  setDataviz,
}: SharedPanelsCardEditionSidebarOptionsLineChartProps) {
  const locale = useCurrentUserLocale();
  const updateDisplayVolumes = useCallback(() => {
    const value = dataviz.displayVolumes ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "displayVolumes",
        value as DatavizLineChart["displayVolumes"]
      )
    );
  }, [dataviz, setDataviz]);

  return (
    <>
      <PeriodEvolution card={card} setCard={setCard} />
      {color}
      <Line title={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LEGEND")}>
        <Checkbox
          label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAY_VOLUMES")}
          checked={dataviz.displayVolumes || undefined}
          onClick={updateDisplayVolumes}
        />
      </Line>
      <TimeUnitOption dataviz={dataviz} card={card} setCard={setCard} />
    </>
  );
}
